import api from "api/api";

export const linkBranchToRegionQuery = async (data) =>
  await api.post(`/settings/branch_per_region`, data);

export const getBranchesPerRegionQuery = async (regionId) =>
  await api.get(`/settings/branch_per_region/${regionId}`);

export const getRegionsPerBranchQuery = async (branchId) =>
  await api.get(`/settings/region_per_branch/${branchId}`);

export const unlinkBranchToRegionQuery = async (data) =>
  await api.delete(`/settings/branch_per_region/${data}`);
